var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('div',[_c('div',[_c('complaintDetails')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }